import { ADDITIONAL_SERVICE_TYPE_CALCULATION, ROUTE_TYPE_CALCULATION } from '@pages/History/consts';
import { HistoryDataLoader } from '@pages/History/types';

import { loadHistoryRouteData } from './components/RouteHistoryItem/helpers';
import { loadHistoryServicesData } from './components/ServiceHistoryItem/helpers';

/**
 * Загрузчик данных по типу расчета, null — если тип не поддерживается
 */
export const getHistoryDataLoader = (typeCalculation: string): HistoryDataLoader | null => {
  switch (typeCalculation) {
    case ROUTE_TYPE_CALCULATION:
      return loadHistoryRouteData;
    case ADDITIONAL_SERVICE_TYPE_CALCULATION:
      return loadHistoryServicesData;
    default:
      return null;
  }
};
